import type { FunctionComponent, ReactNode } from 'react';

import { TASK_LIST_ROW_DIVIDER_CLASS } from '../tile/TaskFieldPrimitives';

/**
 * One row of an automation tile's box: label and value, with what lies behind the value underneath. The step tile's
 * factors and the impact tile's drivers and sums share it, so both tiles read alike.
 */
export const FactorRow: FunctionComponent<{
    readonly children?: ReactNode;
    readonly description?: string;
    /** Sets the row in medium weight, as a total under the rows before it. */
    readonly isTotal?: boolean;
    readonly label: string;
    readonly value: ReactNode;
}> = ({ children, description, isTotal = false, label, value }) => (
    <li className={`flex list-none flex-col gap-xs px-m py-m ${TASK_LIST_ROW_DIVIDER_CLASS}`}>
        <div className={`flex items-baseline gap-m ${isTotal ? 'font-medium' : ''}`}>
            <span className="min-w-0 flex-1 text-body-s text-text-primary">{label}</span>
            <span className="flex shrink-0 items-center gap-s text-body-xs tabular-nums text-text-primary">
                {value}
            </span>
        </div>
        {children}
        {description === undefined ? null : (
            <p className="m-0 text-body-xs leading-normal text-text-muted">{description}</p>
        )}
    </li>
);
